import { render, staticRenderFns } from "./InvoiceBox.vue?vue&type=template&id=1508b7b5&scoped=true&"
import script from "./InvoiceBox.vue?vue&type=script&lang=js&"
export * from "./InvoiceBox.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceBox.vue?vue&type=style&index=0&id=1508b7b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508b7b5",
  null
  
)

export default component.exports